import { InstanceIds } from './instanceIds'
import { getInstanceIdFromUrl } from '@/utils/getInstanceIdFromUrl'
import { isRuntimeEnv } from '@/utils/isRuntimeEnv'

declare global {
  interface Window {
    _etr?: { protocol: string }
    et_proxy_redirect?: string
  }
}

const ETRACKER_DISABLED_INSTANCE_IDS = new Set<string>([
  InstanceIds.DXP_DEV,
  InstanceIds.STANDALONE,
  InstanceIds.TIME_TRACKING_TEST,
  InstanceIds.SYNC_TEST,
  InstanceIds.QST_BUILDER_TEST,
])

export function configureEtracker() {
  if (!shouldConfigureEtracker()) return
  if (document.getElementById('_etLoader')) return

  // Copyright (c) 2000-2026 etracker GmbH. All rights reserved.
  // No reproduction, publication or modification allowed without permission.
  // etracker code 6.0
  window._etr = { protocol: 'https://' }
  window.et_proxy_redirect = '//webcontr.crm.justrelate.com'

  const script = document.createElement('script')
  script.id = '_etLoader'
  script.type = 'text/javascript'
  script.setAttribute('data-block-cookies', 'true')
  script.setAttribute('data-secure-code', 'LVKE9g')
  script.setAttribute('data-page-changed-detection', 'url')
  script.src = 'https://webcontr.crm.justrelate.com/code/e.js'
  script.async = true

  document.head.appendChild(script)
}

function shouldConfigureEtracker() {
  if (typeof window === 'undefined') return false
  if (isRuntimeEnv('dev')) return false

  const { hostname } = window.location
  if (isLocalhost(hostname)) return false
  if (hostname.endsWith('.pages.dev')) return false // Cloudflare builds

  const instanceId = getInstanceIdFromUrl()
  if (instanceId && ETRACKER_DISABLED_INSTANCE_IDS.has(instanceId)) {
    return false
  }

  return true
}

function isLocalhost(hostname: string) {
  return (
    hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1'
  )
}
